import { GetProductFeaturesForNonPdpPageParams, getProductFeaturesForNonPdpPage } from './get-product-features-for-non-pdp-page';
import { submitMerge } from '@otto-ec/tracking-bct';

export type AddNonPdpFeaturesToPageImpressionParams = GetProductFeaturesForNonPdpPageParams;
export const addNonPdpFeaturesToPageImpression = ({ variationId }: AddNonPdpFeaturesToPageImpressionParams) => {
    submitMerge(
        {}, /*                          */
        getProductFeaturesForNonPdpPage({
            variationId,
        })
    );
};
